var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62508 5.08333C7.62508 6.25694 6.67369 7.20833 5.50008 7.20833C4.32648 7.20833 3.37508 6.25694 3.37508 5.08333C3.37508 3.90973 4.32648 2.95833 5.50008 2.95833C6.67369 2.95833 7.62508 3.90973 7.62508 5.08333Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.541748 5.08333C0.541748 8.80208 5.50008 12.875 5.50008 12.875C5.50008 12.875 10.4584 8.80208 10.4584 5.08333C10.4584 2.34208 8.24133 0.125 5.50008 0.125C2.75883 0.125 0.541748 2.34208 0.541748 5.08333ZM1.95841 5.08333C1.95841 3.12449 3.54124 1.54167 5.50008 1.54167C7.45893 1.54167 9.04175 3.12449 9.04175 5.08333C9.04175 6.40133 8.1098 8.00848 6.89227 9.46517C6.40065 10.0534 5.90612 10.566 5.50008 10.9607C5.09404 10.566 4.59951 10.0534 4.1079 9.46517C2.89036 8.00848 1.95841 6.40133 1.95841 5.08333Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOutline);
export default __webpack_public_path__ + "static/media/location_outline.19866002.svg";
export { ForwardRef as ReactComponent };